function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApiSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FAD24D"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#EDB937"
    },
    cx: 256,
    cy: 421.64,
    rx: 182.28,
    ry: 14.369
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666"
    },
    d: "M65.982,67.222h380.036c12.486,0,22.7,10.217,22.7,22.703V324.03H43.282V89.925 C43.282,77.439,53.496,67.222,65.982,67.222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#15BDB2"
    },
    d: "M58.695,308.614h394.607V89.922c0-3.979-3.308-7.287-7.287-7.287H65.979 c-3.976,0-7.287,3.308-7.287,7.287v218.693L58.695,308.614L58.695,308.614z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M468.718,324.03v24.826c0,12.489-11.261,22.703-25.026,22.703H68.305 c-13.765,0-25.026-10.214-25.026-22.703V324.03h425.436H468.718z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M144.153,234.3H131.29l-2.201-14.717h-15.643l-2.201,14.717H99.54l12.979-81.119h18.657 l12.979,81.119H144.153z M115.064,208.573h12.284l-6.14-41.024L115.064,208.573z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M168.837,153.181c6.413,0,11.182,1.7,14.314,5.099c3.129,3.399,4.693,8.384,4.693,14.951v10.544 c0,6.568-1.563,11.549-4.693,14.949c-3.129,3.399-7.901,5.099-14.314,5.099h-6.025v30.476h-12.748V153.18h18.773V153.181z  M162.812,164.769v27.465h6.025c2.009,0,3.554-0.54,4.635-1.624c1.081-1.081,1.621-3.09,1.621-6.025v-12.168 c0-2.935-0.54-4.944-1.621-6.025c-1.083-1.081-2.628-1.621-4.635-1.621h-6.025V164.769z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M193.75,153.181h12.748V234.3H193.75V153.181z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M367.541,206.507l4.024-15.339l-9.107-3.575c0.307-3.438,0.288-6.901-0.055-10.34l9.073-3.67 l-4.184-15.295l-9.663,1.458c-1.437-3.101-3.179-6.091-5.228-8.932l6.02-7.709l-11.274-11.155l-7.646,6.101 c-2.861-2.02-5.872-3.733-8.983-5.136l1.358-9.679l-15.339-4.024l-3.575,9.107c-3.438-0.307-6.903-0.291-10.34,0.055l-3.667-9.073 l-15.297,4.184l1.458,9.663l0.005-0.002c-3.098,1.435-6.091,3.179-8.932,5.228l-7.709-6.022l-11.155,11.274l6.101,7.646 c-2.02,2.861-3.733,5.87-5.136,8.983l-9.679-1.358l-4.024,15.339l9.107,3.575c-0.307,3.438-0.288,6.901,0.055,10.34l-9.073,3.667 l4.184,15.297l9.66-1.458c1.437,3.098,3.179,6.091,5.228,8.932l-6.02,7.709L269,233.453l7.646-6.101 c2.858,2.02,5.87,3.733,8.983,5.136l-1.358,9.676l15.339,4.026l3.575-9.107c3.438,0.307,6.901,0.288,10.34-0.055l3.67,9.073 l15.295-4.184l-1.458-9.66c3.101-1.437,6.091-3.179,8.932-5.228l7.709,6.02l11.155-11.271l-6.101-7.646 c2.02-2.858,3.733-5.87,5.136-8.983L367.541,206.507z M325.84,200.282c-9.713,9.813-25.538,9.894-35.35,0.184 c-9.813-9.713-9.895-25.537-0.184-35.35c9.713-9.813,25.538-9.894,35.35-0.184C335.469,174.645,335.55,190.47,325.84,200.282z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECF0F1"
    },
    d: "M308.071,150.421c-17.826,0-32.279,14.45-32.279,32.279c0,17.826,14.451,32.279,32.279,32.279 c17.826,0,32.279-14.451,32.279-32.279C340.35,164.874,325.9,150.421,308.071,150.421z M325.84,200.284 c-9.713,9.813-25.538,9.894-35.35,0.184c-9.813-9.712-9.895-25.537-0.184-35.35c9.713-9.813,25.538-9.894,35.35-0.184 C335.469,174.647,335.55,190.472,325.84,200.284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M417.06,242.49c0.098-1.815,0.006-3.649-0.285-5.477l5.244-2.987l-5.957-12.386l-5.65,2.028 c-1.236-1.38-2.605-2.605-4.076-3.67l1.598-5.821l-12.971-4.546l-2.563,5.429c-1.815-0.098-3.649-0.006-5.477,0.285l-2.986-5.241 l-12.386,5.959l2.028,5.647c-1.377,1.236-2.605,2.605-3.67,4.076l-5.821-1.598l-4.546,12.971l5.429,2.565 c-0.097,1.812-0.008,3.649,0.283,5.474l-5.244,2.987l5.957,12.386l5.65-2.028c1.238,1.377,2.607,2.605,4.076,3.67l-1.595,5.821 l12.971,4.546l2.563-5.432c1.812,0.1,3.649,0.008,5.477-0.283l2.985,5.244l12.386-5.957l-2.028-5.647 c1.38-1.239,2.605-2.608,3.67-4.079l5.821,1.598l4.546-12.971L417.06,242.49z M400.732,250.72c-5.309,5.367-13.963,5.408-19.329,0.1 c-5.363-5.31-5.408-13.963-0.1-19.329c5.309-5.365,13.963-5.408,19.329-0.1C405.997,236.702,406.041,245.353,400.732,250.72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECF0F1"
    },
    d: "M391.016,221.639c-10.752,0-19.468,8.716-19.468,19.468s8.716,19.468,19.468,19.468 c10.752,0,19.468-8.716,19.468-19.468C410.484,230.355,401.768,221.639,391.016,221.639z M400.73,250.72 c-5.309,5.365-13.963,5.408-19.326,0.1c-5.366-5.309-5.411-13.963-0.103-19.326v-0.003c5.312-5.367,13.963-5.411,19.329-0.1 C405.995,236.699,406.039,245.353,400.73,250.72z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#B6B6B8"
    },
    cx: 256,
    cy: 346.8,
    r: 7.814
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C2C2C4"
    },
    d: "M305.065,407.271l36.095,11.564H170.836l29.123-11.564v-35.712h105.104v35.712H305.065z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B6B6B8"
    },
    d: "M305.065,407.271l-105.104-35.712h105.104V407.271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECF0F1"
    },
    d: "M199.959,407.271h105.104l36.095,11.564v4.981h-85.161h-85.163v-4.981l29.123-11.564H199.959z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiSvgrepoCom);
export default __webpack_public_path__ + "static/media/api-svgrepo-com.c78a370b7617485ccaab4249c55a901f.svg";
export { ForwardRef as ReactComponent };